<template>
  <section id="services" class="our-services">
    <div class="background-container">
      <!-- Contenedor para el fondo -->
    </div>
    
    <div class="content-container">
      <div class="content">
        <div class="title-section">
          <h1 class="section-title">{{ translate('landing.our_services', 'OUR SERVICES') }}</h1>
        </div>
        
        <div class="services-grid">
          <div class="service-card" @click="goToService('pawpulse')">
            <div class="service-icon">
              <div class="icon-number">01</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            </div>
            <h2 class="service-title">{{ translate('landing.pawpulse_service', 'PAWPULSE') }}</h2>
          </div>
          
          <div class="service-card" @click="goToService('outsourcing')">
            <div class="service-icon">
              <div class="icon-number">02</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
            </div>
            <h2 class="service-title">{{ translate('landing.outsourcing', 'OUTSOURCING') }}</h2>
          </div>
          
          <div class="service-card" @click="goToService('consultancy')">
            <div class="service-icon">
              <div class="icon-number">03</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon></svg>
            </div>
            <h2 class="service-title">{{ translate('landing.consultancy', 'CONSULTANCY') }}</h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'OurServices',
  components: {
    // Sin componentes adicionales
  },
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  },
  data() {
    return {}
  },
  methods: {
    goToService(service) {
      this.$emit('scrollToService', service)
    }
  }
}
</script>

<style scoped>
/* Usando las variables globales de fuentes definidas en App.vue */
:root, body, * {
  font-family: var(--font-primary);
}

:root {
  /* Variables globales si son necesarias */
}

.our-services {
  position: relative;
  min-height: 70vh;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr;
  color: white;
  overflow: hidden;
}

/* Contenedor para el fondo */
.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/technopawsImages/ourservices.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #094D4E; /* Color de fondo que extiende la imagen */
  z-index: 1;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7rem; /* Reducido el espacio entre elementos */
  box-sizing: border-box;
}

.title-section {
  text-align: center;
}

.section-title {
  /* Ahora usamos la clase global h1 para tamaño, color y peso */
  margin: 0;
  letter-spacing: 2px;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  justify-content: center;
}

.service-card {
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 1.5rem; /* Reducido el padding */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem; /* Reducido el espacio entre elementos */
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer; /* Añadimos cursor pointer para indicar que es clickeable */
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.service-icon {
  position: relative;
  width: 65px; /* Reducido tamaño */
  height: 65px; /* Reducido tamaño */
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-number {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #09405c;
  color: white;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: bold;
}

.icon {
  width: 40px;
  height: 40px;
  color: white;
}

.service-title {
  /* Ahora usamos la clase global h2 para tamaño, color y peso */
  margin: 0;
  letter-spacing: 1px;
}

/* Media queries para móviles pequeños */
@media (max-width: 480px) {
  .our-services {
    min-height: 30vh;
    padding: 3rem 0;
  }
  
  .content {
    gap: 1.5rem;
  }
  
  .section-title {
    /* El tamaño ahora viene de la clase h1 en media queries */
    letter-spacing: 0px;
  }
  
  .service-icon {
    width: 45px;
    height: 45px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
  
  .service-card {
    padding: 0.8rem;
  }
  
  .service-icon {
    width: 50px;
    height: 50px;
  }

  .icon {
    width: 22px;
    height: 22px;
  }
  
  .icon-number {
    width: 20px;
    height: 20px;
    font-size: 0.7rem;
    top: -8px;
    right: -8px;
  }
  
  .service-title {
    margin-top: 0.5rem;
    letter-spacing: 0px;
  }
}

</style>
